import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ba13d74"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CalculatorResult" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = { class: "font-semibold text-lg" }
const _hoisted_4 = { class: "flex items-center ml-3" }
const _hoisted_5 = {
  key: 0,
  class: "flex items-center justify-center mt-3"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "Экспресс доставка невозможна внутри города", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  class: "flex items-center justify-center mt-3"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-sm" }, "Загрузка результата...", -1))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "mt-2 font-semibold" }
const _hoisted_12 = { class: "mt-2" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "mt-2 font-semibold" }
const _hoisted_15 = { class: "font-semibold" }
const _hoisted_16 = { class: "mt-2 underline" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  key: 2,
  class: "font-semibold"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-2 font-semibold" }, "Доп. услуги", -1))
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 2 }
const _hoisted_24 = { key: 3 }
const _hoisted_25 = { key: 4 }
const _hoisted_26 = { key: 5 }
const _hoisted_27 = { key: 6 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cheap = _resolveComponent("cheap")!
  const _component_loader = _resolveComponent("loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.fromCityName) + " - " + _toDisplayString(_ctx.whereCityName) + " (" + _toDisplayString(_ctx.shipmentTypeId === 1 ? 'Эконом' : 'Экспресс') + ") ", 1),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.isHasPickup)
          ? (_openBlock(), _createBlock(_component_cheap, {
              key: 0,
              class: _normalizeClass(["small mr-3", { primary: _ctx.isHasPickup }])
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Самовывоз ")
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        (_ctx.isHasSelfDelivery)
          ? (_openBlock(), _createBlock(_component_cheap, {
              key: 1,
              class: _normalizeClass(["small", { primary: _ctx.isHasSelfDelivery }])
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Самопривоз ")
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.isShowMessageCityEquals)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_loader, { class: "primary mr-1" }),
                _hoisted_9
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_ctx.isFtl)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("p", _hoisted_11, "Стоимость: " + _toDisplayString(_ctx.finalCost) + " ₸", 1),
                      _createElementVNode("p", _hoisted_12, "Стоимость доставки: " + _toDisplayString(_ctx.deliveryCost) + " ₸", 1),
                      _createElementVNode("p", null, "Стоимость простоя: " + _toDisplayString(_ctx.downtimeCost) + " ₸", 1),
                      _createElementVNode("p", null, "НДС: " + _toDisplayString(_ctx.vatCoefficient), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("p", _hoisted_14, "Стоимость итого: " + _toDisplayString(_ctx.cost) + " ₸", 1),
                      _createElementVNode("p", _hoisted_15, " Стоимость за перевозку: " + _toDisplayString(_ctx.deliveryCharge) + " ₸ (с учетом НДС) ", 1),
                      _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.TARIFFS[_ctx.tariffId]), 1),
                      _createElementVNode("p", null, "Стоимость страхования: " + _toDisplayString(_ctx.insuranceCost) + " ₸ (с учетом НДС)", 1),
                      _createElementVNode("p", null, "Терминальная обработка: " + _toDisplayString(_ctx.packagingCost) + " ₸ (с учетом НДС)", 1),
                      _createElementVNode("p", null, "Стоимость выгрузки: " + _toDisplayString(_ctx.unloadCost) + " ₸", 1),
                      (Boolean(_ctx.declaredPrice))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_17, " Объявленная стоимость: " + _toDisplayString(_ctx.declaredPrice) + " ₸ ", 1))
                        : _createCommentVNode("", true),
                      (Boolean(_ctx.productName))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_18, "Наименование товара: " + _toDisplayString(_ctx.productName), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("p", null, "Время доставки: до " + _toDisplayString(_ctx.days) + " рабочих дней", 1),
                      (Boolean(_ctx.weightTypeToCalculate))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_ctx.weightTypeToCalculate) + ": " + _toDisplayString(_ctx.usedWeightInKg) + " кг ", 1))
                        : _createCommentVNode("", true)
                    ])),
                (Boolean(_ctx.isCanRenderAdditionalServiceDelivery))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _hoisted_20,
                      (_ctx.additionalServiceDelivery.craneCost)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_21, " Стоимость крана: " + _toDisplayString(_ctx.additionalServiceDelivery.craneCost) + " ₸ ", 1))
                        : _createCommentVNode("", true),
                      (_ctx.additionalServiceDelivery.gridCost)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_22, " Стоимость обрешетки: " + _toDisplayString(_ctx.additionalServiceDelivery.gridCost) + " ₸ ", 1))
                        : _createCommentVNode("", true),
                      (_ctx.additionalServiceDelivery.hydraulicTrolleyCost)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_23, " Стоимость рохли: " + _toDisplayString(_ctx.additionalServiceDelivery.hydraulicTrolleyCost) + " ₸ ", 1))
                        : _createCommentVNode("", true),
                      (_ctx.additionalServiceDelivery.loaderCost)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_24, " Стоимость грузчиков: " + _toDisplayString(_ctx.additionalServiceDelivery.loaderCost) + " ₸ ", 1))
                        : _createCommentVNode("", true),
                      (_ctx.additionalServiceDelivery.manipulatorCost)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_25, " Стоимость манипулятора: " + _toDisplayString(_ctx.additionalServiceDelivery.manipulatorCost) + " ₸ ", 1))
                        : _createCommentVNode("", true),
                      (_ctx.additionalServiceDelivery.palletCost)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_26, " Стоимость паллет: " + _toDisplayString(_ctx.additionalServiceDelivery.palletCost) + " ₸ ", 1))
                        : _createCommentVNode("", true),
                      (_ctx.additionalServiceDelivery.softPackageCost)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_27, " Стоимость мягкой упаковки: " + _toDisplayString(_ctx.additionalServiceDelivery.softPackageCost) + " ₸ ", 1))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ], 64))
        ], 64))
  ]))
}